"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { CheckboxProvider } from "./use-checkbox-context.js";
import { useCheckbox } from "./use-checkbox.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-root.tsx
var splitRootProps = createSplitProps();
var CheckboxRoot = forwardRef((props, ref) => {
	const [useCheckboxProps, localProps] = splitRootProps(props, [
		"checked",
		"defaultChecked",
		"disabled",
		"form",
		"id",
		"ids",
		"invalid",
		"name",
		"onCheckedChange",
		"readOnly",
		"required",
		"value"
	]);
	const checkbox = useCheckbox(useCheckboxProps);
	const mergedProps = mergeProps(checkbox.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(CheckboxProvider, {
		value: checkbox,
		children: /* @__PURE__ */ jsx(ark.label, {
			...mergedProps,
			ref
		})
	});
});
CheckboxRoot.displayName = "CheckboxRoot";
//#endregion
export { CheckboxRoot };
